import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AuthService } from '../shared/auth.service';
import { AuthProvider } from '../model/AuthProvider';

@Directive({
    selector: '[isCustomerEngineer]',
    standalone: false
})
export class IsCustomerEngineerDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {

  }

  public ngOnInit(): void {

    if (this.authService.isCustomerEngineer()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
